<template>
  <div class="cavans-area" id="cavansArea">
    <canvas
      @mousedown="mouseDown"
      @mousemove="mouseMove"
      @mouseup="mouseUp"
      @touchend="touchEnd"
      @touchmove="touchMove"
      @touchstart="touchStart"
      ref="canvas"
    ></canvas>
    <span :class="classes" v-if="!hasDrew">签名区</span>
  </div>
</template>

<script>
export default {
  name: "esignPanel",
  props: {
    direction: {
      type: String,
      default: "horizontal", //"vertical"
    },
    lineWidth: {
      type: Number,
      default: 4,
    },
    lineColor: {
      type: String,
      default: "#000000",
    },
    bgColor: {
      type: String,
      default: "",
    },
    isCrop: {
      type: Boolean,
      default: false,
    },
    isClearBgColor: {
      type: Boolean,
      default: true,
    },
    format: {
      type: String,
      default: "image/png",
    },
    quality: {
      type: Number,
      default: 1,
    },
  },
  data () {
    return {
      width: 800,
      height: 300,
      hasDrew: false,
      resultImg: "",
      points: [],
      canvasTxt: null,
      startX: 0,
      startY: 0,
      isDrawing: false,
      sratio: 1,
    }
  },
  computed: {
    ratio () {
      return this.height / this.width
    },
    stageInfo () {
      return this.$refs.canvas.getBoundingClientRect()
    },
    myBg () {
      return this.bgColor ? this.bgColor : "rgba(255, 255, 255, 0)"
    },
    classes () {
      return {
        signTxt: true,
        signTxtVertical: this.direction == "vertical",
      }
    },
  },
  watch: {
    myBg: function (newVal) {
      this.$refs.canvas.style.background = newVal
    },
  },
  beforeMount () {
    window.addEventListener("resize", this.$_resizeHandler)
    this.$nextTick(() => {
      this.height = document.getElementById('cavansArea') ? document.getElementById('cavansArea').clientHeight : 0
      this.width = document.getElementById('cavansArea') ? document.getElementById('cavansArea').clientWidth : 0
      const canvas = this.$refs.canvas
      canvas.height = this.height
      canvas.width = this.width
      canvas.style.background = this.myBg
      this.$_resizeHandler()
      // 在画板以外松开鼠标后冻结画笔
      document.onmouseup = () => {
        this.isDrawing = false
      }
    })
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.$_resizeHandler)
  },
  methods: {
    $_resizeHandler () {
      const canvas = this.$refs.canvas
      canvas.style.width = this.width + "px"
      const realw = parseFloat(window.getComputedStyle(canvas).width)
      canvas.style.height = this.ratio * realw + "px"
      this.canvasTxt = canvas.getContext("2d")
      this.canvasTxt.scale(1 * this.sratio, 1 * this.sratio)
      this.sratio = realw / this.width
      this.canvasTxt.scale(1 / this.sratio, 1 / this.sratio)
    },
    // pc
    mouseDown (e) {
      e = e || event
      e.preventDefault()
      this.isDrawing = true
      this.hasDrew = true
      let obj = {
        x: e.offsetX,
        y: e.offsetY,
      }
      this.drawStart(obj)
    },
    mouseMove (e) {
      e = e || event
      e.preventDefault()
      if (this.isDrawing) {
        let obj = {
          x: e.offsetX,
          y: e.offsetY,
        }
        this.drawMove(obj)
      }
    },
    mouseUp (e) {
      e = e || event
      e.preventDefault()
      let obj = {
        x: e.offsetX,
        y: e.offsetY,
      }
      this.drawEnd(obj)
      this.isDrawing = false
    },
    // mobile
    touchStart (e) {
      e = e || event
      e.preventDefault()
      this.hasDrew = true
      if (e.touches.length === 1) {
        let obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top,
        }
        this.drawStart(obj)
      }
    },
    touchMove (e) {
      e = e || event
      e.preventDefault()
      if (e.touches.length === 1) {
        let obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top,
        }
        this.drawMove(obj)
      }
    },
    touchEnd (e) {
      e = e || event
      e.preventDefault()
      if (e.touches.length === 1) {
        let obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top,
        }
        this.drawEnd(obj)
      }
    },
    // 绘制
    drawStart (obj) {
      this.startX = obj.x
      this.startY = obj.y
      this.canvasTxt.beginPath()
      this.canvasTxt.moveTo(this.startX, this.startY)
      this.canvasTxt.lineTo(obj.x, obj.y)
      this.canvasTxt.lineCap = "round"
      this.canvasTxt.lineJoin = "round"
      this.canvasTxt.lineWidth = this.lineWidth * this.sratio
      this.canvasTxt.stroke()
      this.canvasTxt.closePath()
      this.points.push(obj)
    },
    drawMove (obj) {
      this.canvasTxt.beginPath()
      this.canvasTxt.moveTo(this.startX, this.startY)
      this.canvasTxt.lineTo(obj.x, obj.y)
      this.canvasTxt.strokeStyle = this.lineColor
      this.canvasTxt.lineWidth = this.lineWidth * this.sratio
      this.canvasTxt.lineCap = "round"
      this.canvasTxt.lineJoin = "round"
      this.canvasTxt.stroke()
      this.canvasTxt.closePath()
      this.startY = obj.y
      this.startX = obj.x
      this.points.push(obj)
    },
    drawEnd (obj) {
      this.canvasTxt.beginPath()
      this.canvasTxt.moveTo(this.startX, this.startY)
      this.canvasTxt.lineTo(obj.x, obj.y)
      this.canvasTxt.lineCap = "round"
      this.canvasTxt.lineJoin = "round"
      this.canvasTxt.stroke()
      this.canvasTxt.closePath()
      this.points.push(obj)
      this.points.push({ x: -1, y: -1 })
    },
    // 操作
    initSing (signBase64) {
      if (this.direction == "vertical") {
        // 旋转图片
        this.rotateBase64(signBase64, 90).then((img) => {
          this.draw(img)
        })
      } else {
        this.draw(signBase64)
      }
    },
    draw (signBase64) {
      const canvas = this.$refs.canvas
      const canvasTxt = canvas.getContext("2d")
      canvasTxt.lineCap = "round"
      canvasTxt.lineJoin = "round"
      this.canvasTxt.strokeStyle = this.lineColor
      canvasTxt.lineWidth = this.lineWidth * this.sratio
      let img = new Image()
      img.src = signBase64
      img.width = canvas.width
      img.height = canvas.height
      img.onload = () => {
        canvasTxt.drawImage(img, 0, 0)
        this.hasDrew = true
      }
    },
    generate (options) {
      let imgFormat = options && options.format ? options.format : this.format
      let imgQuality = options && options.quality ? options.quality : this.quality
      const pm = new Promise((resolve, reject) => {
        if (!this.hasDrew) {
          reject(`Warning: Not Signned!`)
          return
        }
        var resImgData = this.canvasTxt.getImageData(
          0,
          0,
          this.$refs.canvas.width,
          this.$refs.canvas.height
        )
        this.canvasTxt.globalCompositeOperation = "destination-over"
        this.canvasTxt.fillStyle = this.myBg
        this.canvasTxt.fillRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height)
        this.resultImg = this.$refs.canvas.toDataURL(imgFormat, imgQuality)
        var resultImg = this.resultImg
        this.canvasTxt.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height)
        this.canvasTxt.putImageData(resImgData, 0, 0)
        this.canvasTxt.globalCompositeOperation = "source-over"
        if (this.isCrop) {
          const crop_area = this.getCropArea(resImgData.data)
          var crop_canvas = document.createElement("canvas")
          const crop_ctx = crop_canvas.getContext("2d")
          crop_canvas.width = crop_area[2] - crop_area[0]
          crop_canvas.height = crop_area[3] - crop_area[1]
          const crop_imgData = this.canvasTxt.getImageData(...crop_area)
          crop_ctx.globalCompositeOperation = "destination-over"
          crop_ctx.putImageData(crop_imgData, 0, 0)
          crop_ctx.fillStyle = this.myBg
          crop_ctx.fillRect(0, 0, crop_canvas.width, crop_canvas.height)
          resultImg = crop_canvas.toDataURL(imgFormat, imgQuality)
          crop_canvas = null
        }

        if (this.direction == "vertical") {
          // 旋转图片
          this.rotateBase64(resultImg, -90).then((img) => {
            resolve(img)
          })
        } else {
          resolve(resultImg)
        }
      })
      return pm
    },
    reset () {
      this.canvasTxt.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height)
      if (this.isClearBgColor) {
        this.$emit("update:bgColor", "")
        this.$refs.canvas.style.background = "rgba(255, 255, 255, 0)"
      }
      this.points = []
      this.hasDrew = false
      this.resultImg = ""
    },
    getCropArea (imgData) {
      var topX = this.$refs.canvas.width
      var btmX = 0
      var topY = this.$refs.canvas.height
      var btnY = 0
      for (var i = 0; i < this.$refs.canvas.width; i++) {
        for (var j = 0; j < this.$refs.canvas.height; j++) {
          var pos = (i + this.$refs.canvas.width * j) * 4
          if (
            imgData[pos] > 0 ||
            imgData[pos + 1] > 0 ||
            imgData[pos + 2] ||
            imgData[pos + 3] > 0
          ) {
            btnY = Math.max(j, btnY)
            btmX = Math.max(i, btmX)
            topY = Math.min(j, topY)
            topX = Math.min(i, topX)
          }
        }
      }
      topX++
      btmX++
      topY++
      btnY++
      const data = [topX, topY, btmX, btnY]
      return data
    },
    rotateBase64 (src, edg) {
      return new Promise((resolve, reject) => {
        var canvas = document.createElement("canvas")
        var ctx = canvas.getContext("2d")
        var imgW //图片宽度
        var imgH //图片高度
        var size //canvas初始大小

        if (edg % 90 != 0) {
          console.error("旋转角度必须是90的倍数!")
          throw "旋转角度必须是90的倍数!"
        }
        edg < 0 && (edg = (edg % 360) + 360)
        const quadrant = (edg / 90) % 4 //旋转象限
        const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 } //裁剪坐标

        var image = new Image()
        image.crossOrigin = "anonymous"
        image.src = src

        image.onload = function () {
          imgW = image.width
          imgH = image.height
          size = imgW > imgH ? imgW : imgH

          canvas.width = size * 2
          canvas.height = size * 2
          switch (quadrant) {
            case 0:
              cutCoor.sx = size
              cutCoor.sy = size
              cutCoor.ex = size + imgW
              cutCoor.ey = size + imgH
              break
            case 1:
              cutCoor.sx = size - imgH
              cutCoor.sy = size
              cutCoor.ex = size
              cutCoor.ey = size + imgW
              break
            case 2:
              cutCoor.sx = size - imgW
              cutCoor.sy = size - imgH
              cutCoor.ex = size
              cutCoor.ey = size
              break
            case 3:
              cutCoor.sx = size
              cutCoor.sy = size - imgW
              cutCoor.ex = size + imgH
              cutCoor.ey = size + imgW
              break
          }

          ctx.translate(size, size)
          ctx.rotate((edg * Math.PI) / 180)
          ctx.drawImage(image, 0, 0)

          var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey)
          if (quadrant % 2 == 0) {
            canvas.width = imgW
            canvas.height = imgH
          } else {
            canvas.width = imgH
            canvas.height = imgW
          }
          ctx.putImageData(imgData, 0, 0)
          resolve(canvas.toDataURL("image/png"))
        }
      })
    },
  },
};
</script>
<style scoped>
.cavans-area {
  position: relative;
  height: 100%;
}
canvas {
  width: 100%;
  height: 100%;
  display: block;
}

.signTxt {
  pointer-events: none;
  height: 70px;
  opacity: 1;
  color: #b3b5b9ff;
  font-size: 3rem;
  font-weight: 600;
  font-family: 'PingFang SC';
  text-align: center;
  line-height: 70px;
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  bottom: 0;
  right: 0;
  margin: auto;
}
.signTxtVertical {
  transform: rotate(90deg);
}
</style>